<template>
  <div class="aboutRange">
    <div>
      <img src="../assets/images/picture_02.png" alt="">
      <div class="ideaText">
        <div class="fz28">“保险的应用场景，包罗万象，无所不在”</div>
      </div>
    </div>
    <div class="compText">将保险作为风险转嫁工具，以最小成本解决财务风险，是为睿智之选。<br>在壹心保代，聚合市场优选产品，可一站式解决个人、家庭、企业等风险管理需求。</div>
    <div class="colorTitle">
      <span>///</span> 业务范围 <span>///</span>
    </div>
    <div class="businessArea">
      <div class="businessItem">
        <div><img src="../assets/images/brief_icon_renshen.png" alt=""></div>
        <div class="itemTitle fz20">人身险</div>
        <div class="itemText">覆盖全生命周期<br>的完善保障方案</div>
      </div>
      <div class="businessItem">
        <div><img src="../assets/images/brief_icon_caichan.png" alt=""></div>
        <div class="itemTitle fz20">财产险</div>
        <div class="itemText">主动式风险评测<br>顾问式规划服务</div>
      </div>
      <div class="businessItem">
        <div><img src="../assets/images/brief_icon_tuanti.png" alt=""></div>
        <div class="itemTitle fz20">团体险</div>
        <div class="itemText">弹性福利定制</div>
      </div>
      <!-- <div class="businessItem">
        <div><img src="../assets/images/brief_icon_hulianwang.png" alt=""></div>
        <div class="itemTitle fz20">互联网保险</div>
        <div class="itemText">轻松自主的选择</div>
      </div> -->
    </div>
    <div class="colorTitle">
      <span>///</span> 机构布局 <span>///</span>
    </div>
    <div class="rangeImg">
      <img src="../assets/images/picture_34.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'aboutRange',
    components: {},
    data() {
      return {

      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .aboutRange {
    width: 1024px;
    margin: 0 auto;

    &>div {
      margin-top: 40px;
      position: relative;

      .ideaText {
        width: 100%;
        color: #ffffff;
        position: absolute;
        top: 192px;
        text-align: center;

        &>div:first-child {
          font-weight: 600;
        }
      }

      img {
        width: 100%;
      }
    }

    .rangeImg {
      width: 768px;
      margin: 40px auto;

      img {
        width: 768px;
      }
    }

    .businessArea {
      padding: 0 92px;
      display: flex;
      justify-content: space-between;

      .businessItem {
        width: 232px;
        height: 287px;
        background: #FFFFFF;
        box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 68px;
        }

        .itemTitle {
          font-weight: 600;
          margin: 48px 0 16px;
        }

        .itemText {
          color: #666666;
        }
      }
    }
  }
</style>